var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { NavLinksContainer, NavLink, } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/NavLinks';
import VerticalTextLinks from '../../components/VerticalTextLinks';
import transformAemPath from '../../components/NavLinks/cms-path-to-url';
import styles from '../../components/NavLinks/index.module.scss';
import { NAV_LINKS } from '../../constants/cmsResourceTypes';
const NavLinks = ({ componentId, navigationLinks, styleIds }) => {
    const isVerticalTextLinks = styleIds === null || styleIds === void 0 ? void 0 : styleIds.includes('vertical-text-links');
    if (!(navigationLinks === null || navigationLinks === void 0 ? void 0 : navigationLinks.length))
        return null;
    const links = navigationLinks.map(navLink => {
        const url = transformAemPath(navLink.url);
        return {
            label: navLink.text,
            component: 'a',
            target: navLink.newWindow ? '_blank' : undefined,
            href: url,
        };
    });
    if (isVerticalTextLinks) {
        return React.createElement(VerticalTextLinks, { links: links });
    }
    return (React.createElement("div", { className: styles.before },
        React.createElement(NavLinksContainer, { linkElement: "a", id: componentId, backgroundColor: "scallop", "data-testid": "nav-links" }, links.map((_a) => {
            var { label } = _a, linkProps = __rest(_a, ["label"]);
            return (React.createElement(NavLink, Object.assign({}, linkProps, { key: label }), label));
        }))));
};
NavLinks.resourceType = NAV_LINKS;
export default NavLinks;
//# sourceMappingURL=index.js.map